var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.05 363.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333033;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2-2",
    "data-name": "Layer 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2-2",
    "data-name": "Layer 1-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.05,131.72c-1.41,8-2.4,16-4.31,23.87-5.05,20.73-15.19,39-27.85,56-19.54,26.18-43.3,48.31-67.82,69.64q-43.36,37.72-87,75.11c-11.15,9.6-23.14,10-33.89.69-37.79-32.77-75.68-65.44-113-98.72C56,241.2,38.74,222.12,24.68,200.41-.54,161.49-7.38,119.78,8.59,75.94,23,36.3,51.07,10.36,93.16,2.24c43.63-8.41,78.77,7.21,106.68,40.82,1.52,1.83,2.93,3.76,4.79,6.15,1.71-2.18,3.2-4.13,4.75-6,16.18-19.8,35.9-34.29,61.13-40.27,44-10.42,90.69,8,116.09,45.3,12.55,18.45,19.49,38.82,21.73,60.91.15,1.42.48,2.83.72,4.25Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHeart);
export default __webpack_public_path__ + "static/media/black_heart.3bbe6e572990b5b9f945124d68bd2feb.svg";
export { ForwardRef as ReactComponent };